import React from "react";
import { Link } from "react-router-dom"

const DetailsRow = ({ days }) => {
  const RowElement = (job, idx) => {
    const {
      jobId, jobNo, jobServiceId, draftmanName, jobTitle, type, startDate, finishDate, workedTime
    } = job

    return (
      <tr key={`${draftmanName}-${jobNo}-${idx}`}>
        <td>{draftmanName}</td>
        <td>{jobNo}</td>
        <td>
          <Link to={`/jobs/${jobId}/job_services/${jobServiceId}`} target="_blank" className="link-no-decoration">{jobTitle}</Link>
        </td>
        <td>{type}</td>
        <td>{startDate}</td>
        <td>{finishDate}</td>
        <td>{`${workedTime} Hrs`}</td>
      </tr>
    )
  }

  return (
    <>
      { days.map((day, dayIdx) => {
        const { jobs, total } = day

        return (
          <React.Fragment key={dayIdx}>
            { jobs.map((job, idx) => RowElement(job, idx)) }
            <tr className="font-weight-bold text-white" style={{ backgroundColor: "#6c757d" }}>
              <td>Total</td>
              <td colSpan={4}></td>
              <td>{`${total?.jobsComplete} Jobs`}</td>
              <td>{`${total?.totalWorkedTime} Hrs`}</td>
            </tr>
          </React.Fragment>
        )
      })}
    </>
  )
}

export default DetailsRow
